import { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import { FourthStepAction, Server2 } from '../../redux/actions/auth/auth.actions'
import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js';
import { useStripe,  useElements,  PaymentElement,  Elements } from "@stripe/react-stripe-js";
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-D3Y4J4RSR8');

export const Subscribe = ({ setPopupSubscribe }) => {
  const userData = useSelector((state) => state?.auth?.user?.user)
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE);
  // set all data of Get api in state
  const [planName, setPlanName] = useState();
  const [planType, setPlanType] = useState();
  const [planPrice, setPlanPrice] = useState();
  // const [planId, setPlanID] = useState();
  const [clientSecret, setClientSecret] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState(null);
  // let navigate = useNavigate();
  // let dispatch = useDispatch();

  const appearance = {
    theme: "flat",
  };
  const options = {
    clientSecret,
    appearance,
  };
  useEffect(() => {
    const data = {
      email:userData?.email,
      fname:userData?.fname
    }
    var config = {
      method: "POST",
      url: Server2 + "/stripe/getSubscriptionPlan",
      headers: { "Content-Type": "application/json" },
      data:data
    };

    axios(config)
      .then(function (response) {
        console.log(response?.data?.data, "response?.data?.data");
        setPlanName(response?.data?.data?.plan_name);
        setPlanType(response?.data?.data?.plan_interval);
        setPlanPrice(response?.data?.data?.plan_price);
        // setPlanID(response?.data?.data?.plan_id);
        setClientSecret(response?.data?.data?.clientSecret);
      })
      .catch(function (error) {
        setError(error)
        console.log(error, "i am error Fourth");
      });
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  function CheckoutForm({ clientSecret  , id , email , setMessage , setError}) {
  const created = new Date()
  const Expiry = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const { error } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: "https://www.ibouge.com/dashboard",
      },
    });
    if (error) {
      setMessage(error.message)
      console.log("[error]", error);
    } else {
      if (!stripe) {
        return;
      }
      if (!clientSecret) {
        return;
      }
      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        document.documentElement.scrollTop = 0;
        switch (paymentIntent.status) {
          case "requires_payment_method":
            setMessage("Your payment was not successful, please try again.");
            break;
          case "processing":
            setMessage("Your payment is processing.");
            break;
          case "succeeded":
            ReactGA.event({
              category: 'User',
              action: 'Checkout',
              label: 'Premium Subscription',
            });
            window.clarity("set", "page","Checkout" );
            setMessage("Payment succeeded!");
            dispatch(FourthStepAction({
              id:id,
              email:email,
              IntentId:paymentIntent.id,
              amount:paymentIntent.amount,
              createdDate:created,
              expiryDate:Expiry
            }))
              .then((res) => {
                console.log('bought');
                if (res?.data?.user?.subscription) {
                  navigate("/dashboard");
                } else {
                  setError(res?.data.message);
                }
              })
              .catch((error) => {
                console.log(error, "error");
              });
            break;
          default:
            setMessage("Something went wrong.");
            break;
        }
      });
    }
  };
  return (
    <>
    
    <form onSubmit={handleSubmit}>
      <div style={{ margin: "5px 20px" }}>
        <PaymentElement />
      </div>
      <div className="d-flex justify-content-center w-100">
        <button type="submit" className= "submit-btn2 w-100 mx-2">
        Activate my iBouge Business Page
        </button>
      </div>
    </form>
    </>
  );
}

  return (
    <>
      <div
        style={{
          height: "100vh",
          width: "100%",
          position: "fixed",
          top: "0px",
          zIndex: "1000",
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(85, 71, 119, 0.6)",
        }}
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="border rounded-2 bg-white pb-3 mx-3" style={{width: 400, marginTop: '60px'}} >

            <div className="rounded-1 py-2 text-white d-flex align-items-center justify-content-between"
              style={{ backgroundColor: "#6148a1" }}>
              <p className="fw-bold mx-3 my-2 text-white">Activate Premium Plan</p>

              <FiX
                className="fs-4 text-white me-3"
                role="button"
                onClick={() => setPopupSubscribe(false)}
              />
            </div>

            <div style={{ overflowY: "auto", margin: "1px 0px"}}>
              <div style={{maxWidth: '400px'}} className='mx-auto mt-2 mb-4'>
                {message ? (
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      margin: "2px 28px 10px 28px",
                      textAlign: "center",
                      color: message === "Payment succeeded!" ? "#198754" : "red"
                    }}
                  >
                    {message}
                  </div>
                ) : (null)}
                {error ? (
                  <div
                    className="text-danger"
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      margin: "2px 28px 10px 28px",
                      textAlign: "center",
                    }}
                  >
                    {error}
                  </div>
                ) : ( "" )}

                <div className="position-relative">
                  <label className="thirdlabel">Plan Name</label>
                  {/* <BiChevronDown size={36} className="aicloseinput" /> */}
                  <div className="d-flex justify-content-center">
                    <select
                      className="form-select form-select-sm AccountType mx-2"
                      name="Plan Name"
                      defaultValue={"PlanName"}
                    >
                      <option
                        value="PlanName"
                        className="p-2 text-dark"
                        disabled
                        hidden
                      >
                        {planName}
                      </option>
                      <option className="p-2 text-dark">{planName}</option>
                    </select>

                  </div>
                </div>
                <div className="position-relative">
                  <label className="thirdlabel">Plan Type</label>
                  {/* <BiChevronDown size={36} className="aicloseinput" /> */}
                  <div className="d-flex justify-content-center w-100">
                    <select
                      className="form-select form-select-sm AccountType mx-2"
                      name="Plan Name"
                      defaultValue={"PlanType"}
                    >
                      <option
                        value="PlanType"
                        className="p-2 text-dark"
                        disabled
                        hidden
                      >
                        {planType === "year" ? " Annual" : ""}
                      </option>
                      <option className="p-2 text-dark">
                        {planType === "year" ? " Annual" : ""}
                      </option>
                    </select>
                  </div>
                </div>
                <div className="position-relative">
                  <label className="thirdlabel">Plan Price</label>
                  {/* <BiChevronDown size={36} className="aicloseinput" /> */}
                  <div className="d-flex justify-content-center w-100">
                    <select
                      className="form-select form-select-sm AccountType mx-2"
                      name="Membership"
                      defaultValue={"Membership"}
                    >
                      <option
                        value="Membership"
                        className="p-2 text-dark"
                        disabled
                        hidden
                      >
                        Business Membership ${planPrice} USD / Annually
                      </option>
                      <option className="p-2 text-dark">
                        Business Membership ${planPrice} USD / Annually
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {clientSecret && (
                <Elements stripe={stripePromise} options={options}>
                  <CheckoutForm
                    clientSecret={clientSecret}
                    id={userData?._id}
                    email={userData?.email}
                    setError={(e) => setError(e)}
                    setMessage={(e) => setMessage(e)}
                  />
                </Elements>
              )}
            </div>

          </div>
        </div>
      </div>
    </>
  )
}